import { render } from "./TheMyCollectionLeftColumn.vue?vue&type=template&id=5b8614bb&scoped=true&ts=true"
import script from "./TheMyCollectionLeftColumn.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionLeftColumn.vue?vue&type=script&lang=ts"

import "./TheMyCollectionLeftColumn.vue?vue&type=style&index=0&id=5b8614bb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8614bb"]])

export default __exports__